import React from 'react';
import { connect } from 'react-redux';

import requireAuth from '../../components/hocs/requireAuth';
import requireOnboarding from '../../components/hocs/requireOnboarding';
import ClubItem from '../../components/Clubs/ClubItem';
import * as actions from '../../actions/club-actions';
import LearnMoreUtrCollegePopUp from '../../components/Upgrade/UpgradeToUtrCollege/LearnMoreUtrCollegePopUp';
import UpgradeToPerformanceHsPopUp from '../../components/Upgrade/UpgradeToPerformanceHs/UpgradeToPerformanceHsPopUp';
import UpgradeToProClubPopUp from '../../components/Upgrade/UpgradeToProClubPopUp';
import SplashBall from '../../components/Splash/splashBall';

import styles from './clubs.scss';

export class Clubs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            showLearnMoreUtrCollegePopup: false,
            showUpgradeToPerformanceHsPopup: false,
            showProClubPopup: false,
            clubToUpgrade: null,
        };
        this.upgradeToCollege = this.upgradeToCollege.bind(this);
        this.upgradeToPerformanceHs = this.upgradeToPerformanceHs.bind(this);
        this.handleProClubSuccess = this.handleProClubSuccess.bind(this);

        this.handlePerformanceHsPopupCloseClick = this.handlePerformanceHsPopupCloseClick.bind(this);
        this.handlePerformanceHsPopupUpgradeClick = this.handlePerformanceHsPopupUpgradeClick.bind(this);
    }

    componentDidMount() {
        this.props.getAllClubs();
    }

    upgradeToCollege(clubId, name) {
        this.setState({
            showLearnMoreUtrCollegePopup: true,
            clubToUpgrade: [{
                value: clubId,
                label: name,
                tierTypeName: 'free college',
            }],
        });
    }

    upgradeToPerformanceHs(clubId, name) {
        this.setState({
            showUpgradeToPerformanceHsPopup: true,
            clubToUpgrade: [{
                value: clubId,
                label: name,
                tierTypeName: 'high school',
            }],
        });
    }

    handlePerformanceHsPopupCloseClick() {
        this.setState({
            showUpgradeToPerformanceHsPopup: false,
            clubToUpgrade: null,
        });
    }

    handlePerformanceHsPopupUpgradeClick() {
        this.setState({
            showUpgradeToPerformanceHsPopup: false,
            showProClubPopup: true,
        });
    }

    handleProClubSuccess() {
        setTimeout(() => {
            window.location.reload();
        }, 3000);
    }

    render() {
        const ClubHeaderColumns = () => {
            return (
                <div>
                    <div className={`${styles.clubHeaders} d-flex`}>
                        <div className={`col-md-5 col-4 ${styles.clubHeaderColumn}`}>Name</div>
                        <div className={`col-md-2 d-none d-md-block ${styles.clubHeaderColumn}`}>Status</div>
                        <div className={`col-md-2 col-4 ${styles.clubHeaderColumn}`}>Role</div>
                        <div className={`col-md-3 col-4 ${styles.clubHeaderColumn}`}> </div>
                    </div>
                </div>
            );
        };

        return (
            <div className={`${styles.clubs}`}>
                <div className={`container`}>
                    {(this.props.rows.length > 0) ? (
                        <React.Fragment>
                            <ClubHeaderColumns />
                            <div>
                                {this.props.rows.map(club => (
                                    <ClubItem
                                        key={`club-${club.id}`}
                                        {...club}
                                        upgradeToCollege={this.upgradeToCollege}
                                        upgradeToPerformanceHs={this.upgradeToPerformanceHs}
                                    />
                                ))}
                            </div>
                        </React.Fragment>
                    ) : (
                        <div>
                            {this.state.isLoading && (
                                <SplashBall title="Clubs" description="Loading..." />
                            )}
                            {!this.state.isLoading && (
                                'You are not a member of any clubs.'
                            )}
                        </div>
                    )}
                </div>
                {(this.state.showLearnMoreUtrCollegePopup) && (
                    <LearnMoreUtrCollegePopUp
                        data-testid="modal.clubs.learn-more-college"
                        onCloseClick={() => {
                            this.setState({
                                showLearnMoreUtrCollegePopup: false,
                                clubToUpgrade: null,
                            });
                        }}
                        handleUpgradeClick={() => {
                            this.setState({
                                showLearnMoreUtrCollegePopup: false,
                                showProClubPopup: true,
                            });
                        }}
                        clubOptionsToUpgrade={this.state.clubToUpgrade}
                    />
                )}
                {(this.state.showUpgradeToPerformanceHsPopup) && (
                    <UpgradeToPerformanceHsPopUp
                        onCloseClick={this.handlePerformanceHsPopupCloseClick}
                        handleUpgradeClick={this.handlePerformanceHsPopupUpgradeClick}
                        clubOptionsToUpgrade={this.state.clubToUpgrade}
                    />
                )}

                {(this.state.showProClubPopup && this.state.clubToUpgrade) && (
                    <UpgradeToProClubPopUp
                        data-testid="modal.clubs.upgrade-pro-club"
                        skipIntro={true}
                        onCloseClick={() => {
                            this.setState({
                                showProClubPopup: false,
                                clubToUpgrade: null,
                            });
                        }}
                        onSuccess={this.handleProClubSuccess}
                        clubId={this.state.clubToUpgrade[0].value}
                        clubTierType={{ name: this.state.clubToUpgrade[0].tierTypeName }}
                        clubName={this.state.clubToUpgrade[0].label}
                    />
                )}
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getAllClubs: () => {
            dispatch(actions.getAllClubs());
        },
    };
}

function mapStateToProps(state) {
    return {
        user: state.auth.user,
        ...state.club,
    };
}

function loadData({ dispatch }) {
    return dispatch(actions.getAllClubs());
}

export default {
    component: requireAuth(requireOnboarding(connect(
        mapStateToProps,
        mapDispatchToProps,
    )(Clubs))),
    loadData,
};
